import React from "react";
//#region components
import { StyledButton } from "components/common";
import { Grid } from "@mui/material";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { SurveyTodoButtonProps } from "models/propTypes/annualAccountPropTypes";
//endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { useNavigate, useLocation } from "react-router-dom";

const SurveyTodoButton: React.FC<SurveyTodoButtonProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onClicked = () => {
    navigate(UrlHelper.formatPath(`/Survey/${props.surveyStatus.surveyId}`), {
      state: { background: location }
    });
  };

  const onBookAdvisoryClicked = () => {
    window.open("https://www.wint.se/boka-radgivning#bokslutsgenomgang", "_blank");
  };

  return (
    <Grid container direction="row" spacing={1} className={cssExports.titledContainerButtons}>
      <Grid item>
        <StyledButton size="sm" onClick={onClicked}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Survey.FillOutForm)}
        </StyledButton>
      </Grid>
      <Grid item>
        <StyledButton size="sm" onClick={onBookAdvisoryClicked}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Survey.BookAdvisoryBooking)}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default SurveyTodoButton;
